export class ErrorMessages {
    public static INVALID_COD_FORMAT = 'cost-center:invalid_code_format';
    public static DUPLICATED_COST_CENTER = 'cost-center:duplicated_cost_center';
}